<div *ngIf='(viewStateDtl$ | async) as v'>

    <app-page-loader [vm]="v"></app-page-loader>

    <div class="col-xl-2 col-md-2 col-lg-2 my-2" *ngIf="successMessage">
        <div class="alert alert-success" role="alert">
            {{successMessage}}
        </div>
    </div>
    <div class="col-xl-2 col-md-2 col-lg-2 my-2" *ngIf="errorMessage">
        <div class="alert alert-success" role="alert">
            {{errorMessage}}
        </div>
    </div>

    <div class="row justify-content-md-center" *ngIf="!v.workingText && !v.errorText">
        
        <div class="col-md-12 my-4">
            
            <div class="card card-cascade narrower">
                <mdb-card>
                    <mdb-body>
                        <div class="row">
                            <div class="col-xl-2 col-md-2 col-lg-2 mr-0">
                                <div class="view view-cascade gradient-card-header blue-gradient py-2">
                                    <h6 class="h5-responsive card-title font-weight-bold mb-0">{{v.confirmationNumber}}
                                    </h6>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-12 col-md-12 col-lg-12 mr-0">
                            <div class="card-body h6">
                                <div class="row">
                                    <div class="col-md-3">
                                        <div>
                                            <h6 class="text-muted">Customer</h6>
                                            <p class="h6-responsive">{{v.customer}}</p>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div>
                                            <h6 class="text-muted">Passenger</h6>
                                            <p class="h6-responsive">{{v.passenger}}</p>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div>
                                            <h6 class="text-muted">Vehicle Type</h6>
                                            <p class="h6-responsive">{{v.vehicleType}}</p>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div>
                                            <h6 class="text-muted">Service Area Code</h6>
                                            <p class="h6-responsive">{{v.serviceAreaCode}}</p>
                                        </div>
                                    </div>
                                </div>
                                <hr>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div>
                                            <h6 class="text-muted">Pickup Address</h6>
                                            <p class="h6-responsive">{{v.pickupAddress}}</p>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div>
                                            <h6 class="text-muted">Destination Address</h6>
                                            <p class="h6-responsive">{{v.destinationAddress}}</p>
                                        </div>
                                    </div>
                                </div>
                                <hr>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div>
                                            <h6 class="text-muted">Accounting Feedback</h6>
                                            <p class="h6-responsive">{{v.feedback}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </mdb-body>
                </mdb-card>
            </div>
            
            <!-- Mobile -->
            <div class="d-block d-md-none">
                <mdb-card cascade="true" narrower="true" class="pt-3">
                    <mdb-card-body cascade="true" class="pb-0 pt-2">
                        <mdb-card-text>
                            <div *ngFor="let d of v.items">
                                <div *ngIf='d.userFullName' class="row">
                                    <div class="col-4 text-right text-muted">User Name:</div>
                                    <div class="col-8 "><strong>{{d.userFullName}}</strong></div>
                                </div>
                                <div *ngIf='d.userGroups' class="row">
                                    <div class="col-4 text-right text-muted">User Groups:</div>
                                    <div class="col-8"><strong>{{d.userGroups}}</strong></div>
                                </div>
                                <div *ngIf='d.changeDateTime' class="row">
                                    <div class="col-4 text-right text-muted">Chg.DateTime:</div>
                                    <div class="col-8"><strong>{{d.changeDateTime}}</strong></div>
                                </div>
                                <div class="row">
                                    <div class="col-4 text-right text-muted">Prop. Name:</div>
                                    <div class="col-8"><strong>{{d.propertyName}}</strong></div>
                                </div>
                                <div class="row">
                                    <div class="col-4 text-right text-muted">Old Value:</div>
                                    <div class="col-8"><strong>{{d.oldValue | currency}}</strong></div>
                                </div>
                                <div class="row">
                                    <div class="col-4 text-right text-muted">New Value:</div>
                                    <div class="col-8"><strong>{{d.newValue | currency}}</strong></div>
                                </div>
                                <div class="row">
                                    <div class="col-4 text-right text-muted">Comm Old:</div>
                                    <div class="col-8"><strong>{{d.commissionsOldValue | currency}}</strong></div>
                                </div>
                                <div class="row">
                                    <div class="col-4 text-right text-muted">Comm New:</div>
                                    <div class="col-8 h6"><strong>{{d.commissionsNewValue | currency}}</strong></div>
                                </div>
                                <hr />
                            </div>
                        </mdb-card-text>
                    </mdb-card-body>
                </mdb-card>
            </div>

            <!-- Desktop-->
            <div class="d-none d-md-block">
                <div class="card card-cascade narrower">
                    <mdb-card>
                        <mdb-body>
                            <div class="row">
                                <div class="col-xl-12 col-md-12 col-lg-12 mr-0">
                                    <div class="card-body card-body-cascade">
                                        <div class="row">
                                            <div class="table-responsive">
                                                <table *ngIf='!v.isNotFound' class="table">
                                                    <thead class="text-muted h6">
                                                        <tr>
                                                            <th class="th-lg">User Name</th>
                                                            <th class="th-lg">ChangeDate Time</th>
                                                            <th class="th-lg">User Group</th>
                                                            <th class="th-lg">Property Name</th>
                                                            <th class="th-lg">Old Value</th>
                                                            <th class="th-lg">New Value</th>
                                                            <th class="th-lg">Commissions Old Value</th>
                                                            <th class="th-lg">Commissions New Value</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody class="h6">
                                                        <tr *ngFor="let d of v.items">
                                                            <td>
                                                                {{d.userFullName}}
                                                            </td>
                                                            <td>
                                                                {{d.changeDateTime}}
                                                            </td>
                                                            <td>
                                                                {{d.userGroups}}
                                                            </td>
                                                            <td>
                                                                <span
                                                                    [ngClass]="{'text-danger': d.manualChanged }">{{d.propertyName}}</span>
                                                            </td>
                                                            <td>
                                                                <span
                                                                    [ngClass]="{'text-danger': d.manualChanged }">{{d.oldValue
                                                                    | currency}}</span>
                                                            </td>
                                                            <td>
                                                                <span
                                                                    [ngClass]="{'text-danger': d.manualChanged }">{{d.newValue
                                                                    | currency}}</span>
                                                            </td>
                                                            <td>
                                                                {{d.commissionsOldValue | currency}}
                                                            </td>
                                                            <td>
                                                                {{d.commissionsNewValue | currency}}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </mdb-body>
                    </mdb-card>
                </div>
            </div>

            <!-- acknowledged  section-->
            <div class="row mb-3 mt-lg-2 justify-content-md-center" *ngIf="v.needApproval == 1">
                <div class="col-xl-6 col-lg-12 mb-3">
                    <mdb-card>
                        <!--Card content-->
                        <mdb-card-body>
                            <div>
                                <div class="col-xl-2 col-md-2 col-lg-2 mr-0" *ngIf="workingMessage">
                                    <div class="alert alert-success" role="alert">
                                        {{workingMessage}}
                                    </div>
                                </div>
                                <div>
                                    <!-- Form -->
                                    <form class="text-center" style="color: #757575;">
                                        <!-- feedback -->
                                        <div class="md-form">
                                            <textarea type="text" id="feedback-body"
                                                class="md-textarea md-textarea-auto form-control" mdbInput
                                                [(ngModel)]="vm.body" [ngModelOptions]="{standalone: true}"></textarea>
                                            <label for="feedback-body">Feedback</label>
                                        </div>

                                        <!-- Sign in button -->
                                        <div class="row justify-content-md-center justify-content-sm-center">
                                            <div>
                                                <button mdbBtn color="success" outline="true" rounded="true" block="true"
                                                class="z-depth-0 my-4 waves-effect" mdbWavesEffect type="submit"
                                                (click)="submit(v.resAuditLogEntryId, v.segmentRowId)">Acknowledged</button>
                                            </div>
                                            <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
                                            <div>
                                                <button mdbBtn color="info" outline="true" rounded="true" block="true"
                                                class="z-depth-0 my-4 waves-effect" mdbWavesEffect type="cancel"
                                                (click)="reset()">Reset</button>
                                            </div>
                                            
                                        </div>
                                    </form>
                                    <!-- Form -->
                                </div>
                            </div>

                        </mdb-card-body>

                    </mdb-card>
                </div>
            </div>
        </div>
    </div>
</div>